<template>
    <div class="model feedBack" >
        <div class="svgContainer">
            <svg aria-hidden="true" slot="icon">
                <use xlink:href="#icon-feedBack"></use>
            </svg>
        </div>
        <p><span v-if="phone == null">未绑定手机号</span><span v-if="phone != null">{{phone}}</span></p>
       	<router-link class="phone-binding" to="/user/phone">
       		<span v-if="phone == null">去绑定</span><span v-if="phone != null" style="margin-left: 0.7rem;">修改</span>
       		<div class="right-jiantou-02"></div>
       	</router-link>
    </div>
</template>

<script>

export default {
  props: ['phone'],
  name: 'FeedBack',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
.phone-binding{
	display: flex;
    font-size: 0.16rem;
    color: #009688;
    justify-content: flex-end;
    width: 100%;
    align-items: center;
    margin-right: 5%;
}
.right-jiantou-02{
	width: .13rem;
    height: .13rem;
    border-top: 2px solid #000;
    border-right: 2px solid #000;
    transform: rotate(45deg);
}
.feedBack {
    height: 0.55rem !important;
    display: flex;
    .svgContainer {
        line-height: .75rem;
        margin-right: .2rem;
        margin-left: .2rem;
    }
    p {
        display: inline-block;
        font-size: 0.16rem;
        font-weight: 600;
        width: 2.5rem;
        line-height: 0.55rem;
    }
    svg {
        width: 0.3rem;
        height: 0.3rem;
        line-height: .3rem;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/userDetailElement/BindingPhone.vue